import { RequestService } from '@/services/request.service'
import { Credentials } from '@/entities/Credentials'
import ServerDirections from '@/config/server-directions'
const requestService = new RequestService()

export class AuthRequests {
  login (email, password) {
    function map (data) {
      return { token: data.token }
    }
    const route = ServerDirections.LOGIN
    const method = 'post'
    const body = {
      email,
      password,
    }
    return requestService.makePromise(route, method, { body, noAuth: true }, map)
  }

  sendAccessMail (email) {
    const route = ServerDirections.CREDENTIALS_SEND
    const method = 'post'
    function map (data) {
      return data
    }
    const body = {
      email,
    }
    return requestService.makePromise(route, method, { body, noAuth: true }, map)
  }

  whoAmI () {
    function map (data) {
      return new Credentials(data)
    }
    const route = ServerDirections.WHOAMI
    const method = 'get'
    return requestService.makePromise(route, method, {}, map)
  }
}
